import React, { } from "react";
import { useIntl } from "umi";
import { Modal, Button } from "tea-component";

import "@/pages/dashboard/assets/scss/components/deleteSetting.scss";

const DeleteSetting = (props: any) => {
  const { visible, close, deletedFilter, deleteFilterSchemeList } = props;
  const { filter_name } = deletedFilter;
  const { formatMessage } = useIntl();


  const deleteSelectorScheme = () => {
    deleteFilterSchemeList(deletedFilter, () => { });
    close?.();
  };

  return (
    <Modal visible={visible} caption='' onClose={close}>
      <Modal.Body>
        <div className="deleteSetting-title">{formatMessage({ id: 'filter_save_delete_setting' })}</div>
        <div className="deleteSetting-desc">{formatMessage({ id: 'filter_save_sure_to_delete' }, { name: <span className='dbd_filter_save_delete_name'>{filter_name}</span> })}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button type="primary" onClick={deleteSelectorScheme}>
          {formatMessage({ id: 'common_confirm' })}
        </Button>
        <Button type="weak" onClick={close}>
          {formatMessage({ id: 'common_cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteSetting;
